import { render, staticRenderFns } from "./mainMaterialConsumption.vue?vue&type=template&id=567cdbbb&scoped=true"
import script from "./mainMaterialConsumption.vue?vue&type=script&lang=js"
export * from "./mainMaterialConsumption.vue?vue&type=script&lang=js"
import style0 from "./mainMaterialConsumption.vue?vue&type=style&index=0&id=567cdbbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567cdbbb",
  null
  
)

export default component.exports